export const en = {
    title: `Create Account`,
    description: `Join us today`,
    success: `Account created successfully!`,
    successInstructions: `Please check your email for confirmation.`,
    alreadyHaveAccount: `Already have an account?`,
    failure: `Registration failed. Please try again.`,
};
//# sourceMappingURL=en.js.map